import Vue from 'vue'
import App from './App.vue'
import vSelect from 'vue-select'
import axios from 'axios'
import UIkit from 'uikit'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import JSONView from 'vue-json-component'
import VueHighlightJS from 'vue-highlight.js';
import javascript from 'highlight.js/lib/languages/javascript';

Vue.component('datetime', Datetime);
Vue.component('v-select', vSelect)
Vue.use(VueHighlightJS, {
  // Register only languages that you want
  languages: {
    javascript
  }
})

Vue.use(JSONView);
UIkit

// Override toString on IE for objects
if(navigator.userAgent.indexOf('MSIE')!==-1
  || navigator.appVersion.indexOf('Trident/') > -1){
  // When IE outputs objects, it'll just say [object Object]. No good. Override prototype
  Object.prototype.toString = function() {
    return JSON.stringify(this)
  }
}

Vue.config.productionTip = false

Vue.prototype.$rp = { schema: false } // Attach JSON schema as a global instance property
Vue.prototype.$http = axios // Attach Axios HTTP library as a global instance property

// Setup a simple event bus
const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

// Determine which schema to load based on URL path
function getSchemaFilename() {
  // TODO: re-enable once versioned routes are implemented
  // const path = window.location.pathname;
  // if (path.includes('/v4/')) {
  //   console.log('Loading v4 API schema');
  //   return 'schema.json'; // In the v4 directory, we renamed schema-v4.json to schema.json
  // } else if (path.includes('/v3/')) {
  //   console.log('Loading v3 API schema (not implemented yet)');
  //   return 'schema-v3.json';
  // }
  console.log('Loading v2 API schema');
  return 'schema.json';
}

// Lift off
new Vue({
  created() {
    const schemaFile = getSchemaFilename();
    console.log(`Attempting to load schema from: ${schemaFile}`);
    
    this.$http({
      method: "GET",
      url: schemaFile
    }).then(response => {
      console.log(`Schema loaded successfully from ${schemaFile}`);
      this.$rp.schema = response.data
      
      // Set a version indicator for display purposes
      // TODO: re-enable once versioned routes are implemented
      // if (window.location.pathname.includes('/v4/')) {
      //   this.$rp.apiVersion = 'v4';
      //   console.log('Set API version indicator to v4');
      // } else if (window.location.pathname.includes('/v3/')) {
      //   this.$rp.apiVersion = 'v3';
      //   console.log('Set API version indicator to v3');
      // } else {
      //   this.$rp.apiVersion = 'v2';
      //   console.log('Set API version indicator to v2');
      // }
      this.$rp.apiVersion = 'v2';
      console.log('Set API version indicator to v2');
      
      this.$bus.$emit("loaded")
    }).catch(error => {
      console.error(`Failed to load schema from ${schemaFile}`);
      if (error.response) {
        // Non 2XX Error
        console.error({ data:  error.response, code: error.response.status, message:  error.response.data.error })
      } else if (error.request) {
        // The request was made but no response was received
        console.error({ data: error.toJSON(), code: false, message: error.message })
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error({ data: error.toJSON(), code: false, message: error.message })
      }
    })
  },
  render: h => h(App)
}).$mount('#app')
